/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ForgotPasswordDto interface.
 */
export function instanceOfForgotPasswordDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function ForgotPasswordDtoFromJSON(json) {
    return ForgotPasswordDtoFromJSONTyped(json, false);
}
export function ForgotPasswordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
export function ForgotPasswordDtoToJSON(json) {
    return ForgotPasswordDtoToJSONTyped(json, false);
}
export function ForgotPasswordDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
